export default {
  data() {
    return {
      rules: {
        required: v => !!v,
        numeric: v => {
          const pattern = /^(-)?[0-9]+(.[0-9]+)?$/
          return pattern.test(v)
        },
      },
    }
  },
}